import React from 'react';
import { FormValuesType } from 'src/UI/dynamicUI/types';
import { FormAccordionItemList } from 'src/UI/dynamicUI/layout/DynamicEntitySection';
import { Box, Grid } from '@mantine/core';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';
import { GridPair } from 'src/financial/financial-data/financial-item/forms/common/GridPair';
import { UseFormReturnType } from '@mantine/form';

type BeneficiaryFormAccordionItemListProps = {
  isEditing: boolean;
  form: UseFormReturnType<FormValuesType>;
};

export const BENEFICIARY = 'Beneficiary';

export const BeneficiaryFormAccordionItemList = ({
  form,
  isEditing,
}: BeneficiaryFormAccordionItemListProps) => {
  const untypedItems = form.getValues()[BENEFICIARY];
  const beneficiaries = Array.isArray(untypedItems) ? untypedItems : [];

  const handleAddBeneficiary = () => {
    form.insertListItem(BENEFICIARY, {
      id: null,
      name: '',
      relationship: '',
      percentage: null,
    });
  };

  return (
    <FormAccordionItemList
      value="beneficiaries"
      label="Beneficiaries"
      counterLabel="Beneficiaries"
      button={{
        label: 'Add beneficiary',
        onClick: handleAddBeneficiary,
      }}
      isEditing={isEditing}
      form={form}
      entityType={BENEFICIARY}
    >
      {beneficiaries.map((_, index) => (
        <Box key={index}>
          <Grid>
            <GridPair
              first={<BeneficiaryItem field="name" index={index} />}
              second={<BeneficiaryItem field="relationship" index={index} />}
            />
            <GridPair first={<BeneficiaryItem field="percentage" index={index} />} second={<></>} />
          </Grid>
        </Box>
      ))}
    </FormAccordionItemList>
  );
};

const BeneficiaryItem = ({ field, index }: { field: string; index: number }) => (
  <FinancialFormField field={field} product={BENEFICIARY} index={index} />
);
